export interface IBranchAdminUserAuthorizationConfig {
    isManageMyProfile: string
    isManageBranchProfile: string
    isManageBranchUsers: string
    isCreateBranchUser: string
}

export const BranchAdminUserManagementPrevilages = () => {
    const BranchAdmin: IBranchAdminUserAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchProfile: 'Enabled',
        isManageBranchUsers: 'Enabled',
        isCreateBranchUser: 'Enabled'
    }

    const adminHashMap = new Map<string, IBranchAdminUserAuthorizationConfig>()
    adminHashMap.set('BranchAdminUserManagement', BranchAdmin)

    return adminHashMap
}

export const BranchUserUserManagementPrevilages = () => {
    const BranchUser: IBranchAdminUserAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchProfile: 'Disabled',
        isManageBranchUsers: 'Disabled',
        isCreateBranchUser: 'Disabled'
    }

    const adminHashMap = new Map<string, IBranchAdminUserAuthorizationConfig>()
    adminHashMap.set('BranchUserUserManagement', BranchUser)

    return adminHashMap
}

export const defaultBranchUserManagement: IBranchAdminUserAuthorizationConfig = {
    isManageMyProfile: 'Disabled',
    isManageBranchProfile: 'Disabled',
    isManageBranchUsers: 'Disabled',
    isCreateBranchUser: 'Disabled'
}
